/**
callback:回调函数；
options:选项数组；
selectedOption:选中的选项；
author by you 2015-12-10
**/
'use strict';
angular.module('util.trsSliderBarModule', []).
directive('trsSliderBar', ["$timeout", "$q", function($timeout, $q) {
    return {
        scope: {
            callback: "&"
        },
        restrict: 'E',
        templateUrl: './components/util/trsSliderBar/trsSliderBar.html',
        link: function(scope, iElm, iAttrs, controller) {
            var contentHtml, btn, bar, start, end, step, g, b, m;
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                //bindIcon();
                bindBody();
                btn = iElm.find(".pointer")[0];
                bar = iElm.find(".content")[0];
                start = iElm.find(".start")[0];
                end = iElm.find(".end")[0];
                step = iElm.find(".progress")[0];
                g = document;
                b = window;
                m = Math;
                getFontCssArray();
                var promise;
                calcu(function(per) {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        adjustSize(per, function() {
                            scope.callback(); //preve
                        });
                    }, 400);
                    return promise;
                });
            }

            /**
             * [bindBody description]
             * @return {[type]} [description]
             */
            function bindBody() { //aa
                $("body").click(function(event) {
                    if ($(event.target) === iElm || $(event.target).parents('.trsSliderBar').length > 0) return;
                    $timeout(function() {
                        scope.openStatus = false;
                    });
                    //iElm.find(".scale").removeClass('open');
                });
            }
            /**
             * [add description] 调节进度
             */
            scope.add = function(value) {
                var to = (parseInt(btn.style.left) || 0) + value;
                var max = bar.offsetWidth - btn.offsetWidth; //  最大偏移距离
                to  = to < 0 ? 0 : to > max ? max :to; 
                btn.style.left = to + 'px';
                step.style.width = to + 'px';
                var per = m.round((to + 2) / max * .5 * 100);
                adjustSize(per, function() {
                    scope.callback(); //preve
                });
            };

            /**
             * [calcu description] 拖动进度条
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function calcu(callback) {
                btn.onmousedown = function(e) { //按钮
                    var x = (e || b.event).clientX; // e 或者 window 的clientX （整体偏移）
                    var l = btn.offsetLeft; // 偏移距离
                    var max = bar.offsetWidth - btn.offsetWidth; //  最大偏移距离
                    g.onmousemove = function(e) {
                        var thisX = (e || b.event).clientX; //整体偏移
                        var to = m.min(max, m.max(-2, l + (thisX - x)));
                        btn.style.left = to + 'px';
                        step.style.width = to + 'px';
                        var per = m.round((to + 2) / max * .5 * 100);
                        callback(per);
                    };
                    g.onmouseup = function() {
                        g.onmousemove = null;
                    };
                };
            }
            /**
             * [getFontCssArray description] 初始化获取文字的相关css属性
             * @return {[type]} [description]
             */
            function getFontCssArray() {
                $timeout(function() {
                    contentHtml = $("*[adjustsize]");
                    scope.parentCss = {
                        fontSize: Number(contentHtml.css("fontSize").replace(/px/, "")),
                        "line-height": Number(contentHtml.css("line-height").replace(/px/, ""))
                    };
                    scope.fontCssArray = [];
                    contentHtml.find("*").each(function() {
                        var theFontSize = Number($(this).css("fontSize").replace(/px/, ""));
                        var theLineHeight = Number($(this).css("line-height").replace(/px/, ""));
                        scope.fontCssArray.push({
                            fontSize: theFontSize,
                            "line-height": theLineHeight
                        });
                    });
                }, 2000);
            }
            /**
             * [adjustSize description] 调节字体大小
             * @return {[type]} [description]
             */
            function adjustSize(per, success) {
                var fontSize = scope.parentCss.fontSize * (per / 100) + scope.parentCss.fontSize;
                var lineHeight = scope.parentCss["line-height"] * (per / 100) + scope.parentCss["line-height"];
                var cssArray = [];
                for (var i = 0; i < scope.fontCssArray.length; i++) {
                    var perFont = scope.fontCssArray[i];
                    cssArray.push({
                        fontSize: perFont.fontSize * (per / 100) + perFont.fontSize,
                        "line-height": (perFont["line-height"] * (per / 100) + perFont["line-height"]) + 'px'
                    });
                }
                contentHtml.css({ fontSize: fontSize, "line-height": lineHeight + "px" });
                contentHtml.find("*").each(function(index) {
                    $(this).css(cssArray[index]);
                });
                if (angular.isFunction(success)) success();
            }

        }
    };
}]);